import React from 'react';
import PropTypes from 'prop-types';
import css from '../CreateBudget.module.css';

const StepGuard = ({ allow, children }) => {
  if (!allow) return <h2 className={css.title}>Complete previous step</h2>;
  return children;
};

StepGuard.propTypes = {
  allow: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export default StepGuard;